import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export default function Logo({ 
  className = "", 
  iconOnly = false,
  layout = "vertical" 
}: { 
  className?: string, 
  iconOnly?: boolean,
  layout?: "vertical" | "horizontal"
}) {
  const isVertical = layout === "vertical";

  return (
    <div className={cn(
      "flex items-center gap-6 group select-none",
      isVertical ? 'flex-col text-center' : 'flex-row',
      className
    )}>
      {/* Icon Section */}
      <div className="relative w-24 h-24 flex items-center justify-center transform transition-all duration-700 group-hover:scale-105">
        <img 
          src="/images/logo-jacana.png" 
          alt="Jacana Logo" 
          className={cn(
            "w-full h-full object-contain",
            "opacity-80 group-hover:opacity-100 transition-opacity",
            // If we want it to follow text color, we can use filters for basic colors
            "brightness-0" // Default to black
          )}
        />
      </div>

      {/* Text Section */}
      {!iconOnly && (
        <div className="flex flex-col items-start">
          <span className="font-serif text-5xl tracking-[0.1em] text-brand-primary lowercase mb-[-0.1em]">
            Jacana
          </span>
          <span className="text-[10px] font-mono font-bold uppercase tracking-[0.6em] opacity-40 text-brand-primary pl-1">
            Guide Nature
          </span>
        </div>
      )}
    </div>
  );
}
